export default defineNuxtRouteMiddleware(async ({ path }) => {
  if (['/status/health', '/status/health/'].includes(path)) return
  const { head, meta } = await useSeo(path)

  useHead(head)
  useSeoMeta(meta)
})
